module.exports = __webpack_public_path__ + "static/media/ProfessionalDigital.9738955c.svg";